module.exports = __webpack_public_path__ + "static/media/R740CameronMadisonAlexanderBlvdNW_2018-06-05_1.e774ce7d.jpg";